import type { ReactNode } from 'react';
import { RUNTXT } from './demo-data.js';

/**
 * 树底部的状态图例（原型 v0.22 第 337–344 行）。
 *
 * ## 五个灯，不是六个
 *
 * 灯只有 `run / idle / await / fail / off` 五种（原型 421 行注释、837–838 行的
 * `RUNLAMP` / `RUNTXT`）。**「人工执行」不是灯**——它由 `executor` 与
 * `trig: "manual"` 表达，与运行状态**正交**：一张人工执行的卡同样可以是
 * 「空闲」或「执行中」。
 *
 * 文案直接读原型的 `RUNTXT`，**不在这里重打一遍**——重打就会漂移。
 *
 * ## 图例保留，达成率那一句撤掉
 *
 * 图例说明「这些颜色各代表什么」——**读图所需，不是概念解释**，故保留（C-162 四）。
 *
 * 而原型图例右边那句「％ = 近 30 业务日达成率」撤掉：达成率没有表、本轮也明确不建，
 * 而树上不再显示任何百分比，那句话已经没有指向的东西了。
 */
export function TreeLegend(): ReactNode {
  const order: (keyof typeof RUNTXT)[] = ['run', 'idle', 'await', 'fail', 'off'];
  return (
    <div className="legend">
      {order.map((key) => (
        <span key={key}>
          <span
            className={`lamp ${key}`}
            style={{ display: 'inline-block', verticalAlign: -1 }}
          />{' '}
          {RUNTXT[key]}
        </span>
      ))}
    </div>
  );
}

